// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"422":"34b036787cdb1995","5520":"53f8fe5dfb96ae69"}[chunkId] + ".css";
};